angular
  .module 'filters'
  .filter 'nl2br', ($sce) ->
    (text) ->
      if text
        escapedText = _.escape text
        return $sce.trustAsHtml escapedText.replace(/\\r\\n/g, '<br/>')
      else
        ''
